import script from "./AstuceJourWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./AstuceJourWidget.vue?vue&type=script&setup=true&lang=ts"

import "./AstuceJourWidget.vue?vue&type=style&index=0&id=cfff55e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfff55e4"]])

export default __exports__